"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GradientBorderContainer = void 0;
var react_1 = __importDefault(require("react"));
var BemBuilder_1 = __importDefault(require("@CommonFrontend/Utils/BemBuilder"));
var c = (0, BemBuilder_1.default)("gradient-border-container");
var GradientBorderContainer = function (_a) {
    var className = _a.className, contentClassName = _a.contentClassName, _b = _a.borderColor, borderColor = _b === void 0 ? "brand" : _b, _c = _a.isRound, isRound = _c === void 0 ? false : _c, children = _a.children;
    var roundClass = isRound ? "round" : "";
    return (react_1.default.createElement("div", { className: "".concat(c(), " ").concat(c("", borderColor), " ").concat(c("", roundClass), " ").concat(className !== null && className !== void 0 ? className : "", " ") },
        react_1.default.createElement("div", { className: "".concat(c("content"), " ").concat(contentClassName !== null && contentClassName !== void 0 ? contentClassName : "", " ").concat(c("content", roundClass)) }, children)));
};
exports.GradientBorderContainer = GradientBorderContainer;
